import { CashResponse, CashResponseMiddleware } from '@cash-web/shared-util-fetch'

import { FlowResponse, FlowStateDispatch } from '../utils'

export const createSetFlowTokenMiddleware =
  ({ state, dispatch }: FlowStateDispatch): CashResponseMiddleware =>
  (response: CashResponse<FlowResponse>, context) => {
    // guard
    // we do not want to set the flow token if we are changing the client scenario (starting flow)
    if (response?.token == null || response?.token === state.flowToken || response.client_scenario != null) {
      return response
    }

    // action
    dispatch({
      type: 'SET_FLOW_TOKEN',
      flowToken: response?.token,
    })

    return response
  }
